var _path, _path2, _ellipse, _ellipse2, _ellipse3, _g, _g2, _path3, _ellipse4, _path4, _ellipse5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdminRespondeR(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "AdminRespondeR",
    width: 270,
    height: 237.59,
    viewBox: "0 0 270 237.59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    fill: "#1c1a24",
    d: "M-4738.555,639.01c2.339,5.154,5.745,10.652,11.284,11.814a13.117,13.117,0,0,0,9.9-2.428,34.691,34.691,0,0,0,7.3-7.458c.139,10.916,8.748,21.129,19.483,23.115s22.428-4.474,26.461-14.618a24.3,24.3,0,0,0,21.679,16.533,24.3,24.3,0,0,0,22.859-14.854l4.7,1.765a15.208,15.208,0,0,0,15.816,2.264,15.209,15.209,0,0,0,8.729-13.382,49.809,49.809,0,0,0,25.522,9.59l-9.759-26.483,18.591-12.1c8.208-7.941,12.909-17.464,7.594-32.651,4.893-.084,12.653-2.278,19.4-8.859-15.229-13.795-28.676-51.79-33.113-60.8s-10.569-17.717-19.689-23.127-21.7-6.855-30.892-1.544l1.438-1.18a176.069,176.069,0,0,0-73.363-32.6c-12.17-2.3-24.889-3.289-36.83,0-22.358,6.158-38.5,26.617-45.771,48.638s-5.882,44.091-7.187,58.857c-.494,5.577-4.18,10.594-8.7,13.895A22.3,22.3,0,0,1-4799,577.44a38.6,38.6,0,0,0,25.771,20.419,23.457,23.457,0,0,0,5.378.618c1.9,5.813,2.911,10.749,7.721,15.938,6.96,5.568,12.242,5.488,17.5,7.914Z",
    "data-name": "Path 44",
    transform: "translate(4799 -449.888)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    fill: "#ff4527",
    d: "M-4764.169,598.021a108.5,108.5,0,0,1-.674-10.9c-1.427-78.483,41.862-92.024,93.036-90.82,42.026.988,63.4,25.23,69.046,65.49q.366,2.6.594,5.125a34.4,34.4,0,0,1,6.435-.177c26.762,1.8,47.592,37.285,21.094,60.611-12.052,10.608-26.654,9.346-37.116,4.754-12.441,32.527-52.227,55.778-75.129,55.778h-37.327c-39.8,0-65.256-42.415-46.526-77.538Z",
    "data-name": "Path 45",
    transform: "translate(4810.58 -450.289)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_11",
    cx: 8.729,
    cy: 8.729,
    fill: "#1c1a24",
    "data-name": "Ellipse 11",
    rx: 8.729,
    ry: 8.729,
    transform: "translate(138.053 120.107)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_12",
    cx: 14.132,
    cy: 14.132,
    fill: "#e4e3c2",
    "data-name": "Ellipse 12",
    rx: 14.132,
    ry: 14.132,
    transform: "translate(133.353 174.102)"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_13",
    cx: 8.729,
    cy: 8.729,
    fill: "#1c1a24",
    "data-name": "Ellipse 13",
    rx: 8.729,
    ry: 8.729,
    transform: "translate(62.837 120.107)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_23",
    "data-name": "Group 23",
    transform: "translate(29.902 109.528)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_4",
    x2: 36.448,
    fill: "none",
    stroke: "#e4e3c2",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    "data-name": "Line 4",
    transform: "translate(143.579 17.243)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_5",
    x2: 12.655,
    fill: "none",
    stroke: "#e4e3c2",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    "data-name": "Line 5",
    transform: "translate(1.838 17.243)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_21",
    "data-name": "Group 21",
    opacity: 0.2,
    transform: "translate(79.646)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    fill: "#e4e3c2",
    d: "M-4703.17,585.425c0,19.358,14.65,35.05,32.726,35.05s32.726-15.692,32.726-35.05-14.652-25.053-32.726-25.053S-4703.17,566.068-4703.17,585.425Z",
    "data-name": "Path 46",
    transform: "translate(4703.17 -560.372)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22",
    "data-name": "Group 22",
    opacity: 0.2,
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    fill: "#e4e3c2",
    d: "M-4622.831,585.425c0,19.358,14.653,35.05,32.727,35.05s32.727-15.692,32.727-35.05-14.653-25.053-32.727-25.053S-4622.831,566.068-4622.831,585.425Z",
    "data-name": "Path 47",
    transform: "translate(4622.831 -560.372)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    fill: "#e4e3c2",
    d: "M-4670.445,562.355c-20.687,0-30.743,7.546-30.743,23.07,0,18.234,13.792,33.067,30.743,33.067s30.743-14.833,30.743-33.067c0-15.524-10.056-23.07-30.743-23.07m0-1.983c18.073,0,32.726,5.7,32.726,25.053s-14.652,35.05-32.726,35.05-32.726-15.692-32.726-35.05,14.65-25.053,32.726-25.053Z",
    "data-name": "Path 48",
    transform: "translate(4782.816 -560.372)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    fill: "#e4e3c2",
    d: "M-4590.106,562.355c-20.687,0-30.742,7.546-30.742,23.07,0,18.234,13.79,33.067,30.742,33.067s30.744-14.833,30.744-33.067c0-15.524-10.056-23.07-30.744-23.07m0-1.983c18.073,0,32.727,5.7,32.727,25.053s-14.653,35.05-32.727,35.05-32.725-15.692-32.725-35.05,14.651-25.053,32.725-25.053Z",
    "data-name": "Path 49",
    transform: "translate(4622.833 -560.372)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    fill: "none",
    stroke: "#e4e3c2",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M-4620.865,576.88h0a12.8,12.8,0,0,0-18.646,0h0",
    "data-name": "Path 50",
    transform: "translate(4702.855 -560.48)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_24",
    "data-name": "Group 24",
    transform: "translate(73.581 123.301)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    fill: "#ff4527",
    d: "M-4603.321,575.766l-27.339,36.68,21.634,12.287",
    "data-name": "Path 51",
    transform: "translate(4632.857 -574.278)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    fill: "#1c1a24",
    d: "M-4608.33,626.207a1.485,1.485,0,0,0,1.294-.752,1.488,1.488,0,0,0-.558-2.028l-20.17-11.456,26.333-35.329a1.488,1.488,0,0,0-.3-2.081,1.486,1.486,0,0,0-2.081.3l-28.344,38.03,23.1,13.12A1.477,1.477,0,0,0-4608.33,626.207Z",
    "data-name": "Path 52",
    transform: "translate(4632.159 -574.265)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    fill: "#1c1a24",
    stroke: "#1c1a24",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    d: "M-4651.357,562.658s-22.273-39.231-37.208-60.24-32.649-19.743-50.874-22.526-20.149,13.911-20.149,13.911c-2.179,4.2-1.253,9.616,1.683,13.331a18.19,18.19,0,0,0,12.295,6.347,32.879,32.879,0,0,0,13.962-1.9l.561-10.859a95.629,95.629,0,0,0,18.745,70.472c-4.568-21.818-1.657-33.589,1.337-47.931.327,8.183.346,18.376,1.688,26.366,4.893,29.149,24.747,51.061,26.829,46.361,9.49-21.43,22.205-28.556,29.191-26.83Z",
    "data-name": "Path 53",
    transform: "translate(4883.475 -450.145)"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_14",
    cx: 21.008,
    cy: 7.657,
    fill: "#1c1a24",
    "data-name": "Ellipse 14",
    rx: 21.008,
    ry: 7.657,
    transform: "translate(73.546 189.331)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    fill: "#e4e3c2",
    d: "M-4643.214,655.207c2.647-3.693,8.406-7.5,15.652-9.907a43.758,43.758,0,0,1,9.729-2.093c3.691,1.38,5.975,3.263,5.975,5.342,0,4.228-9.406,7.656-21.009,7.656A51.656,51.656,0,0,1-4643.214,655.207Z",
    "data-name": "Path 54",
    transform: "translate(4727.42 -451.561)"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_15",
    cx: 14.132,
    cy: 14.132,
    fill: "#e4e3c2",
    "data-name": "Ellipse 15",
    rx: 14.132,
    ry: 14.132,
    transform: "translate(37.171 174.102)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminRespondeR);
export default __webpack_public_path__ + "static/media/AdminRespondeR.4d7cd62556abc17e356488b7ccdd18f3.svg";
export { ForwardRef as ReactComponent };